import React from "react";
import {
  FlatList,
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import ModalHeader from "@/Components/Modals/ModalHeader";
import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { type UserAttributeSet } from "@/schemas/profile/UserAttributeSet";
import { FilterRangeType } from "@/schemas/screen/filters/FilterByRange";

type PickerModalProps = {
  rangeType: FilterRangeType;
  pickerModalVisible: boolean;
  setPickerModalVisible: (visible: boolean) => void;
  updateRangeValue: (rangeType: FilterRangeType, value: AttributeValue) => void;
  attribute: UserAttributeSet;
};

function PickerModal({
  rangeType,
  pickerModalVisible,
  updateRangeValue,
  setPickerModalVisible,
  attribute,
}: PickerModalProps): React.JSX.Element {
  const updateFilter = (item: AttributeValue): void => {
    updateRangeValue(rangeType, item);
  };

  return (
    <Modal
      visible={pickerModalVisible}
      transparent
      onRequestClose={() => setPickerModalVisible(false)}
    >
      <View style={styles.container}>
        <View style={styles.content}>
          <ModalHeader
            title={`Select ${rangeType === FilterRangeType.MIN ? "minimum value" : "maximum value"}`}
            onClose={() => setPickerModalVisible(false)}
          />
          <FlatList
            data={Object.values(attribute.map)}
            keyExtractor={(item) => item.id}
            renderItem={({ item }) => (
              <TouchableOpacity
                style={styles.item}
                onPress={() => {
                  updateFilter(item);
                  setPickerModalVisible(false);
                }}
              >
                <Text style={styles.pickerItemText}>{`${item.label}`}</Text>
              </TouchableOpacity>
            )}
          />
        </View>
      </View>
    </Modal>
  );
}

export default PickerModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    backgroundColor: "white",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 20,
    maxHeight: "80%",
  },
  item: {
    padding: 15,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  pickerItemText: {
    fontSize: 16,
  },
});
